export const playTimes = [1000, 2000, 4000, 7000, 11000, 16000];
